export default class Translation {
  constructor({ translation = {}, defaultTranslation = {} }) {
    this.translation = translation;
    this.defaultTranslation = defaultTranslation;
  }

  key(key) {
    return this.translation[key] || this.defaultTranslation[key];
  }
}

export const rtlRegions = ['ar', 'ar-DZ', 'fa', 'he']

export const mismatchedRegions = {
  "hy": "hy-am",
  "no": "nb",
  "sr-SR": "sr-cyrl",
  "tj": "tg",
  "cy-GB": "cy",
}

export const convertRegionToISOCode = (region) => {
  return mismatchedRegions[region] || region.toLowerCase();
}
